import React, { useEffect, useState } from 'react';
import Header from '../../includes/Header';
import Footer from '../../includes/Footer';
import { useNavigate } from 'react-router-dom';
import { postPaymentVerify } from '../../apiservices/ApiServices';
import Loader from '../../components/Loader/Loader';
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { ToastContainer, toast } from 'react-toastify';
import { Container } from 'react-bootstrap';


const PaymentStatus = () => {
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [data, setData] = useState([]);
    const [postDatas, setPostDatas] = useState([]);
    const [cart, setCart] = useState([]);

    const navigate = useNavigate();



    const hendelClick = () => {
        localStorage.removeItem('payDataPayLoad');
        navigate(`/myorders/${data?.order_hash}`);
    };

    const postPaymentVerifys = async (postData) => {
        try {
            const res = await postPaymentVerify(postData);
            setData(res.data.data);
            //toast.success(res.data.message);
            setLoading(false);

            if (res.data?.data?.is_direct_buy == 0) {
                localStorage.removeItem('cart');
            }

            localStorage.removeItem('BuyNowData');
            localStorage.removeItem('isProceedCheckout');

        } catch (error) {
            setLoading(false);
        }
    };

    useEffect(() => {
        const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
        setCart(storedCart);
    }, []);

    useEffect(() => {

        if (localStorage.getItem('payDataPayLoad')) {
            const postData = JSON.parse(localStorage.getItem('payDataPayLoad'));
            setPostDatas(postData);
            postPaymentVerifys(postData);
        }

        localStorage.removeItem("instockonly");
        localStorage.removeItem("priceRange");
        localStorage.removeItem("selectedFilters");
        localStorage.removeItem("selectedSortBy");
    }, []);


    return (
        <>
            <Header CartTot={cart.length} toast={toast} />
            <ToastContainer />
            <section id='pagecontent'>
                <div className='pagecontent-block'>
                    <Container>
                        {!isLoading ?
                            <>
                                {postDatas?.status == 'success' ?
                                    <div className='pagecontent-box'>
                                        <div className='payicon'>
                                            <FaCheckCircle />
                                        </div>
                                        <h4>Order Confirmed</h4>
                                        <p>Your transaction was completed successfully and your order is now confirmed.</p>
                                        <div className='viewbutton'>
                                            <button className='btn btn-green' onClick={hendelClick}>View Order Details</button>
                                        </div>
                                    </div>
                                    :
                                    <div className='pagecontent-box failure'>
                                        <div className='payicon'>
                                            <FaTimesCircle />
                                        </div>
                                        <h4>Payment Failed</h4>
                                        <p>We couldn’t complete your transaction. Please try again or use a different payment method.</p>
                                        <div className='viewbutton'>
                                            <button className='btn btn-black' onClick={hendelClick}>View Order Details</button>
                                        </div>
                                    </div>
                                }

                            </>
                            : <Loader />
                        }
                    </Container>
                </div>
            </section>
            <Footer toast={toast} />
            {isLoadings ? <Loader /> : null}
        </>

    )
}

export default PaymentStatus